import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Which optional integrations the backend actually has configured.
 *
 * Stripe, the LLM and photo storage all need third-party credentials this
 * deployment does not have. The UI used to render them as though it did, so a
 * prospect clicked "Subscribe" and got a bare 500, and a user's photo upload
 * failed silently. GET /api/config reports the truth; this hook caches it for
 * the session.
 *
 * Defaults to all-disabled while loading, so a feature is never briefly shown as
 * available before the real answer arrives.
 *
 * Note this cannot tell a user that payments are "coming soon" more gracefully
 * than a disabled button and a sentence. That is deliberate: a pricing page
 * offering a tier nobody can buy is worse than one that says what exists.
 */
export function useFeatureFlags() {
  const [features, setFeatures] = useState({
    payments: false,
    ai: false,
    photo_upload: false,
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/config`)
      .then((r) => {
        if (!cancelled && r.data?.features) {
          setFeatures({ ...features, ...r.data.features });
        }
      })
      // A failed config fetch leaves everything disabled. The backend is the
      // authority on what works; if we cannot ask it, do not offer the button.
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { features, loaded };
}

export default useFeatureFlags;